export function xorBytes(bytes: number[]): number {
    return bytes.reduce((result, byte) => result ^ byte, 0)
}
